import { CdkTrapFocus } from "@angular/cdk/a11y";
import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import type { ConfirmationDialogData } from "../../services/confirmation-dialog.service";

@Component({
  selector: "sala-confirmation-dialog",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CdkTrapFocus],
  template: `
    <div
      cdkTrapFocus
      class="relative w-full max-w-md rounded-lg bg-white p-6 shadow-xl dark:bg-gray-800"
      role="alertdialog"
      [cdkTrapFocusAutoCapture]="true"
      [attr.aria-labelledby]="'dialog-title'"
      [attr.aria-describedby]="'dialog-message'"
    >
      <button
        class="absolute top-4 right-4 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
        (click)="cancel.emit()"
      >
        <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>

      <h2 id="dialog-title" class="mb-4 text-xl font-bold text-gray-800 dark:text-white">
        {{ data().title }}
      </h2>

      <p id="dialog-message" class="mb-6 text-gray-600 dark:text-gray-300">
        {{ data().message }}
      </p>

      <div class="flex justify-end space-x-3">
        <button
          class="rounded border border-gray-300 bg-white px-4 py-2 font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
          (click)="cancel.emit()"
        >
          {{ data().cancelText }}
        </button>

        @if (data().showDiscard) {
          <button
            class="rounded bg-gray-500 px-4 py-2 font-medium text-white hover:bg-gray-600 dark:bg-gray-600 dark:hover:bg-gray-700"
            (click)="discard.emit()"
          >
            {{ data().discardText }}
          </button>
        }

        @if (data().showConfirm !== false && data().confirmText) {
          <button
            cdkFocusInitial
            class="rounded px-4 py-2 font-medium text-white"
            style="background-color: var(--color-sala-green)"
            onmouseover="this.style.backgroundColor = 'var(--color-sala-green)'"
            onmouseout="this.style.backgroundColor = 'var(--color-sala-green)'"
            (click)="confirm.emit()"
          >
            {{ data().confirmText }}
          </button>
        }
      </div>
    </div>
  `,
})
export class ConfirmationDialogComponent {
  // Inputs
  readonly data = input.required<ConfirmationDialogData>();

  // Outputs
  readonly confirm = output();
  readonly discard = output();
  readonly cancel = output();
}
